import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

export function AccountDescription({ red, accountDescription, accountType }) {
  let accountName = "Personal Loan";
  const config = useSelector(state => state.StartUp.brand.configFile);
  const { LOCName } = config;

  /* eslint-disable default-case */

  switch (accountDescription) {
    case "CL":
      case "AUTO":
        if (["LACC.SE", "LACC.MR.SE", "LACC.V.S", "LACC.VMR.S"].includes(accountType)) {
          accountName = "Car Loan";
          break;
        }
        accountName = "Personal Loan";
        break;
    case "LoC":
    case "LOC":
      accountName = LOCName;
      break;
  }

  /* eslint-enable default-case */

  return (
    <div className={cx("account-type", { red: red })}>
      <span>{accountName}</span>
    </div>
  );
}

AccountDescription.propTypes = {
  red: PropTypes.bool,
  accountDescription: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
};

AccountDescription.defaultProps = {
  red: false,
};
